export default __webpack_public_path__ + "static/media/deforestation.b377756f.webp";